// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cvat-modal-export-option-item>.ant-select-item-option-content>span[role=img],.cvat-modal-export-select .ant-select-selection-item>span[role=img]{color:#0074d9;margin-right:8px}.cvat-modal-export-switch-use-default-storage{display:table-cell}", ""]);
// Exports
module.exports = exports;
